import angular from 'angular';
import { AccountsServices } from './services/Accounts';
import { AccountsSettingsServices } from './services/AccountSettings';
import { groupsComponent } from './routes/groups/groups';
import { manageGroupComponent } from './routes/groups/manageGroup';

export default angular
  .module('csm.books.accounts', ['ui.grid', 'ui.grid.selection'])
  .service('Accounts', AccountsServices)
  .service('AccountSettings', AccountsSettingsServices)
  .component('groups', groupsComponent)
  .component('manageGroup', manageGroupComponent).name;
